import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotBillGuarantee = ({
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Spot_=_on,_40_svg__a)">
            <path
                fill={spotColor}
                d="M34.4 39.076c-6.746 2.775-12.172-1.247-18.456-4.857C9.534 30.002-.79 31.317.048 22.86c.665-6.725 8.407-7.027 14.496-11.029C20.6 7.835 23.221 5.904 28.44 7.638c5.183 1.739 10.16 5.108 11.292 11.247 1.098 6.143-1.28 17.657-5.332 20.19Z"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M12.628 23.403h5.949m-5.95 4.227h4.49m2.389-20.035v1.922m0 8.646v-1.921m2.402-6.725h-2.402m-2.882 6.725h2.882m0-6.725h-1.2a1.681 1.681 0 0 0 0 3.362h2.4a1.681 1.681 0 1 1 0 3.363h-1.2m-2.882 17.263H8.298A1.207 1.207 0 0 1 7.1 32.289V4.316c0-.671.536-1.216 1.198-1.216h21.56c.661 0 1.197.545 1.197 1.216v10.795m-6.678 15.33-.864 6.509 3.572-2.144 3.573 2.144-.865-6.517m2.294-4.2a5.002 5.002 0 1 1-10.003 0 5.002 5.002 0 0 1 10.003 0Z"
            />
        </g>
        <defs>
            <clipPath id="Spot_=_on,_40_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotBillGuarantee.displayName = "SpotBillGuarantee";
